import React from 'react';
import { graphql, useStaticQuery, Link } from 'gatsby';
import { isBrowser } from '../utils/utils';

const Menu = () => {
  const data = useStaticQuery(graphql`
    query MainMenuQuery {
      allMainMenuJson {
        edges {
          node {
            name
            url
            weight
            target
          }
        }
      }
    }
  `);

  const getMantasMallPage = () => {
    if (!isBrowser()) {
      window.open('https://mall.mantas.cn/');
      return;
    }
    let url = '';
    if (window.location.origin.includes('localhost')) {
      url = `http://localhost:6204/oom/home`;
      window.open(url);
      return;
    }
    const urls = window.location.origin.split('-');
    if (urls.length === 2) {
      url = `${urls[0]}-mall.mantas.cn`;
    } else {
      url = 'https://mall.mantas.cn/';
    }
    window.open(url);
  };

  const getSupplierRegisterPage = () => {
    if (!isBrowser()) return 'https://supplier.mantas.cn/provider/register';
    let url = '';
    if (window.location.origin.includes('localhost')) {
      url = `https://supplier.petkit.cn/provider/register`;
      return url;
    }
    const urls = window.location.origin.split('-');
    if (urls.length === 2) {
      url = `${urls[0]}-supplier.petkit.cn/provider/register`;
    } else {
      url = 'https://supplier.mantas.cn/provider/register';
    }
    return url;
  };

  // 渲染菜单项的函数，避免嵌套三元运算符
  const renderMenuItem = (node) => {
    // 处理需要在新窗口打开的链接
    if (node.target === '_blank') {
      return (
        <a href={node.url} target="_blank" rel="noopener noreferrer">
          {node.name}
        </a>
      );
    }

    // 处理普通的内部链接
    return (
      <Link to={node.url} activeClassName="active">
        {node.name}
      </Link>
    );
  };

  return (
    <div id="main-menu" className="main-menu">
      <ul>
        {data.allMainMenuJson.edges.map(({ node }) => (
          <li key={node.weight}>{renderMenuItem(node)}</li>
        ))}
        <li>
          <button onClick={getMantasMallPage} className="menu_a" type="button">
            登录商城
          </button>
        </li>
      </ul>
    </div>
  );
};

export default Menu;
